import { HomeComponent } from '../home/home.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GlobalAdminGuard } from '../shared/guards/global-admin.guard';
import { AdminComponent } from './admin.component';
import { CategoriesComponent } from './categories/categories.component';
import { NewOrganisationComponent } from './new-organisation/new-organisation.component';
import { AdminOrganisationComponent } from './organisation/organisation.component';
import { OrganisationsComponent } from './organisations/organisations.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'admin',
        component: AdminComponent,
        canActivate: [GlobalAdminGuard],
        children: [
          { path: '', component: HomeComponent, children: [] },
          { path: 'organisations', component: OrganisationsComponent, children: [] },
          {
            path: 'categories',
            component: CategoriesComponent
          },
          {
            path: 'organisations/new',
            component: NewOrganisationComponent
          },
          {
            path: 'organisations/:id',
            component: AdminOrganisationComponent
          }
        ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class AdminRoutingModule {}
